import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserQueryKeys } from '@enums/react-query-keys';
import { User } from '@interfaces/models/user';
import UserService from '@services/user-service';

type UpdatePasswordPayload = {
  password: string;
  oldPassword: string;
};

const useUpdatePassword = (userId: User['id']) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdatePasswordPayload) => UserService.updatePassword(userId, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [UserQueryKeys.USER] }),
  });
};

export default useUpdatePassword;
